import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { ACHIEVEMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/achievements/new")({
  component: () => <DeptContentForm cfg={ACHIEVEMENTS} />,
});
